module.exports = __webpack_public_path__ + "static/media/demographics.728e3f06.jpg";